exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".verify-token[data-v-73169e5c]{position:relative}.verify-token p[data-v-73169e5c]{position:absolute;left:0;right:0;bottom:50px}p.text-center.loaded[data-v-73169e5c]{bottom:0;position:relative;margin-top:80px}", ""]);

// exports
